import React from 'react'
import {FaSwimmingPool} from 'react-icons/fa'
import {FcConferenceCall} from 'react-icons/fc'
import {GiWineBottle} from 'react-icons/gi'
import './Amenities.css'
   
const Amenities = () => {
 
  return (
    <div className='container  mt-5'>
        <div className='rest__headStyle'>
                  <div
                    className='text-hero-bold'
                    style={{ fontSize: "1.2em", fontWeight: "600" }}
                  >
                    Residency Amenities
                    <hr />
                  </div>
                  <div className='text-hero-regular'>
                  Take a look at some of the special amenities you can enjoy at any Residency hotel near you
                  </div>
                </div>
      <div className="row parentAmenities pt-5 pb-5 justify-content-center">
        <div className="col-md-3">
            <div className="card shadow  mb-3">
              <div className="card-header headerImg"><i className='bx bx-wifi'></i></div>
              <div className="card-body">
                <h5 className="card-title text-center">Wifi</h5>
                <p className="card-text text-center">Residency Hotels offer free Wi-Fi for guests. Stay connected throughout your stay.</p>
              </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card  shadow mb-3">
            <div className="card-header headerImg"><FaSwimmingPool/></div>
            <div className="card-body text-secondary">
              <h5 className="card-title text-center">Swimming pool</h5>
              <p className="card-text text-center">Residency Hotels feature a refreshing swimming pool. Dive in and enjoy a refreshing swim.</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card  shadow mb-3">
            <div className="card-header headerImg"><GiWineBottle/></div>
            <div className="card-body text-success">
              <h5 className="card-title text-center mb-2">Exclussive Bar</h5>
              <p className="card-text text-center"> Experience our exclusive bar for sophisticated drinks and relaxation.</p>
            </div>
          </div>
        </div>
      {/* <div className="card border-danger mb-3" style={{maxWidth:"18rem"}}>
        <div className="card-header">Header</div>
        <div className="card-body text-danger">
          <h5 className="card-title">Danger card title</h5>
          <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        </div>
      </div>
      <div className="card border-warning mb-3" style={{maxWidth:"18rem"}}>
        <div className="card-header">Header</div>
        <div className="card-body">
          <h5 className="card-title">Warning card title</h5>
          <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        </div>
      </div>
      <div className="card border-info mb-3"style={{maxWidth:"18rem"}}>
        <div className="card-header">Header</div>
        <div className="card-body">
          <h5 className="card-title">Info card title</h5>
          <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        </div>
      </div>
      <div className="card border-light mb-3" style={{maxWidth:"18rem"}}>
        <div className="card-header">Header</div>
        <div className="card-body">
          <h5 className="card-title">Light card title</h5>
          <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        </div>
      </div> */}
       <div className="col-md-3">
      <div className="card shadow  mb-3 ameniCards">
        <div className="card-header headerImg"><FcConferenceCall/></div>
        <div className="card-body text-dark">
          <h5 className="card-title text-center ">conference Hall</h5>
          <p className="card-text text-center">Residency Hotels: Elevate your events with our conference hall that matche your Event.</p>
        </div>
      </div>
      </div>
</div>
    </div>
  )
}

export default Amenities